export const additionalFieldsValidation = (arr) => {
    return arr.reduce((prev, current) => {
        if(current) {
            prev.values['f_' + current.id] = current.value
            prev.validationRules['f_' + current.id] = {...current.validation, maxLength: 40}
        }
        return prev
    }, {values: {}, validationRules: {}})
}